import React from 'react';
import { NavLink } from 'react-router-dom';
import { RxDashboard } from "react-icons/rx";
import { IoDocumentTextOutline } from "react-icons/io5";
import { BsPerson } from "react-icons/bs";
import { IoDocumentsOutline } from "react-icons/io5";
import { IoCalendarOutline } from "react-icons/io5";
import { TbMoneybag } from "react-icons/tb";
import { BsGear } from 'react-icons/bs';
import { FiLogOut } from 'react-icons/fi';
import { LuListTodo } from "react-icons/lu";
import Ismart from './Assets/title.jpg';
import './Styles/Reuseable/Sidebar.css';
import { useAuth } from './Context/AuthContext';

const Sidebar = () => {
  const { logout } = useAuth();
  return (
    <div className="sidebar">
      <div className="sidebar-brand">
        <img src={Ismart} alt="Ismart" />
      </div>
      <ul className="sidebar-nav">
        <li>
          <NavLink to="/forms/list" activeClassName="active">
            <RxDashboard size={20} />
            <span className="nav-text">Forms</span>
          </NavLink>
        </li>
        <li>
          <NavLink to="/forms/folder" activeClassName="active">
            <IoDocumentTextOutline size={20} />
            <span className="nav-text">Folder</span>
          </NavLink>
        </li>
      </ul>
      <div className="sidebar-bottom">
        <ul className="sidebar-nav">
          {/* <li>
            <NavLink to="/settings" activeClassName="active">
              <BsGear />
              <span className="nav-text">Settings</span>
            </NavLink>
          </li> */}
          <li>
            <NavLink activeClassName="active" onClick={logout}>
              <FiLogOut size={20} />
              <span className="nav-text">Logout</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
